import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import export_dialog from "ulysses/widgets";
import "ulysses/controls/datatable";

"use strict";

function get_grid_options(columns_obs, data_fetch, options) {
    return $.extend({
        responsive: false,
        ajax:function(data, callback, settings) {
            //callback({"data":data_obs()});
            var fetcher = data_fetch(data, settings);
            if (fetcher) {
                fetcher.done(function (result) {
                    callback({
                        "draw": data.draw,
                        "data":result.data,
                        "recordsTotal": result.total,
                        "recordsFiltered": result.total
                    });
                }).fail(function(error) {
                    console.error("grid data failed (cancelled?):", error);
                });
            }
        },
        columns: ko.unwrap(columns_obs),
        deferRender: true,
        dom: 'rstsp',
        bInfo: false,
        bPaginate: true,
        searching: false,
        scrollY: "50vh",
        scrollX: true,
        //scrollCollapse: true,
        //scroller: true,
        serverSide: true,
        bProcessing: true,
        colReorder: true,
        select:true
    }, options || {});
}
function initialise_grid($table, columns_obs, data_fetch, options) {
    var grid_opts = get_grid_options(columns_obs, data_fetch, options);
    
    var grid = $table.DataTable(grid_opts);
    $table.on( 'click', 'tr td:first-child', function () {
        //manipulate selection
        if ( $(this).parent().hasClass('active') ) {
            $(this).parent().removeClass('active');
        }
        else {
            grid.$('tr.active').removeClass('active');
            $(this).parent().addClass('active');
        }
        return false;
    } );
    $table.on( 'click', 'tr', function () {
        var dt = $table.dataTable();
        //execute default action (navigate)
        var rowNos = dt.fnGetPosition(this);
        var row = dt.fnGetData()[rowNos];
        uly.actions.navigateto(row.unique_id.toLowerCase().replace("#", "/"));
    } );
    return grid;
}

ko.bindingHandlers.searchgridwrapper = {
    init: function(elt, va, allbindings, model, context) {
        var search_model = ko.unwrap(va());
        var table_data = ko.unwrap(search_model.table);
        var grid_model = $.extend({},search_model, {
            "columns": ko.pureComputed(function() {
                var columns = ko.unwrap(ko.unwrap(search_model.table).columns);
                columns = $.map(columns, function(col) {
                    if (!Object.isObject(col)) {
                        col = { "field": col, "caption": col };
                    }
                    return {
                        "data": col.field,
                        "mData": col.field,
                        "formatter": "text",
                        "render": uly.formatters.text,
                        "defaultContent": "",
                        "caption": col.caption,
                        "visible": col.field !== "id",
                        "width": "200px"
                    };
                });
                columns.unshift({data: null,defaultContent:'',orderable: false, "width": "25px"});
                return columns;
            }),
            "visible": ko.observable(true)
        });
        var current_cols = ko.unwrap(grid_model.columns);
        var current_order = null;
        var sub_ = grid_model.columns.subscribe(function(newvalue) {
            var different = false;
            if (newvalue != current_cols) {
                if (newvalue.length != current_cols.length)
                    different = true;
                if (!different) {
                    newvalue.map(function(c,i) {
                        if (c.data != current_cols[i].data)
                            different = true;
                    });
                }
            }
            if (true || different) {
                grid_model.visible(false);
                setTimeout(function() {
                    grid_model.visible(true);
                }, 0);
            }
            current_cols = newvalue;
            
        });
        ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
            sub_.dispose();
        });
        $(elt).data("grid-model", grid_model);
        ko.applyBindingsToDescendants(context.createChildContext(grid_model), elt);
        return { "controlsDescendantBindings": true };
        
    },
    update: function(elt, va, allbindings, model, context) {
    }
};

ko.bindingHandlers.searchgrid = {
    init: function(elt, va, allbindings, model, context) {
        var search_model = ko.unwrap(va());
        var columns_obs = model.columns;
        var options = { "displayStart": ko.unwrap(search_model.pager.start_index)}
        var sort = ko.unwrap(search_model.pager.sort_col);
        $.each(columns_obs(), function(key,val) {
            if (val.data == sort) {
                options.order = [[key, ko.unwrap(search_model.pager.sort_dir) ]];
            }
        });
        ko.applyBindingsToDescendants(context, elt);
        var grid = initialise_grid($(elt), columns_obs, fetch_grid_data, options);
        var reordered = false;
        grid.on( 'column-reorder', function ( e, settings, details ) {
            reordered = true;
            //force redraw
            grid.draw("page");
        } );
        
        return { "controlsDescendantBindings": true };

        function fetch_grid_data(dataset, settings) {
            var sort = null;
            var def = null;
            if (reordered) {
                reordered = false;
                var columns = $(elt).dataTable().fnSettings().aoColumns;
                var changed_cols = columns.map(function(c,idx) {
                    if (c._ColReorder_iOrigCol != idx) {
                        return c;
                    }
                });
                if (changed_cols.length) {
                    var new_order = columns.map(function(c,idx) {
                        return c._ColReorder_iOrigCol -1;
                    });
                    new_order = $.map(new_order, function(v) {
                        if (v >= 0)
                            return v;
                        return null;
                    });
                        
                    search_model.table.set_column_ordering(new_order);
                }
            }
            if (dataset.order && dataset.order[0] && dataset.order[0].column) {
                sort = dataset.columns[dataset.order[0].column].data;
                if (sort) {
                    if (dataset.order[0].dir == "desc") {
                        sort = "-"+sort;
                    } else  {
                        sort = "+"+sort;
                    }
                }
                if (sort && sort != search_model.pager.search_sort()) {
                    def = search_model.pager.set_sort(sort);
                }
            }
            if (!def) {
                if (true || dataset.start != ko.unwrap(search_model.pager.start_index))
                {
                    search_model.pager.start_index(dataset.start);
                    def = search_model.query_results("grid");
                
                }
                else
                {
                    def = Promise.Deferred();
                    def.resolve(ko.unwrap(search_model.results));
                }
            }
            return def.then(function(results) {
                var columns = ko.unwrap(columns_obs);
                var result = {
                    "data": $.map(ko.unwrap(search_model.results), function(row) {
                        columns.forEach(function(c) {
                            if (typeof row[c.field_name] == "undefined")
                                row[c.field_name] = null;
                        });
                        return row;
                    }),
                    "total": ko.unwrap(search_model.pager.total),
                    "start": ko.unwrap(search_model.pager.start_index)
                };
                return result;
            });                
        }
    },
    update: function() {
        return {controlsDescendantBindings: true };
    }
};
